import { findDefaultDecision } from "../../modules/employees/EmployeeBulkImportPreview.helpers";

export const buildEffectiveDecisions = ({ analyses = [], decisions = {} }) =>
  analyses.map((analysis, idx) => {
    const existing = decisions[idx];
    if (existing) {
      return existing;
    }
    const defaultAction = findDefaultDecision(analysis);
    const individualId =
      defaultAction === "match"
        ? analysis?.identityMatchCandidate?.id || null
        : null;
    return { action: defaultAction, individualId };
  });

export const isReadyToImport = ({ analyses = [], effectiveDecisions = [] }) => {
  if (!analyses.length) {
    return false;
  }
  return analyses.every((analysis, idx) => {
    const decision = effectiveDecisions[idx];
    if (decision?.action === "skip") {
      return true;
    }
    return analysis.success && !analysis.officeMatchBlocked;
  });
};
